import React from 'react';
import './MenuButton.css';

interface MenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

function MenuButton({ isOpen, onClick }: MenuButtonProps) {
  return (
    <button
      className={`menu-button ${isOpen ? 'open' : ''}`}
      onClick={onClick}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
    >
      <div className="menu-button-content">
        <div className="menu-button-icon">
          <span className="menu-button-line"></span>
          <span className="menu-button-line"></span>
        </div>
        <span className="menu-button-label">MENU</span>
      </div>
    </button>
  );
}

export default MenuButton; 